import React, { ReactNode } from "react";

// 템플릿 문자열 내에서 {key} 패턴을 치환하는 함수
export const replaceTemplateKeys = (
  rawHTML: string,
  values: Record<string, ReactNode | string>
): string => {
  // rawHTML은 아래에선 사용 X
  let replacedHTML = rawHTML;

  Object.entries(values).forEach(([key, value]) => {
    // 동적 RegExp(security/detect-non-literal-regexp) 대신 리터럴 토큰 전역 치환과
    // 동치인 split/join 사용 — key에 정규식 특수문자가 있어도 안전
    const token = `{${key}}`;
    replacedHTML = replacedHTML
      .split(token)
      .join(
        React.isValidElement(value) ? `__REACT_ELEMENT_${key}__` : String(value)
      );
  });
  return replacedHTML;
};
